<template>
  <div class="container vertical-align login">
      <TopoComponent></TopoComponent>

      <div class="row">
        <div class="col-md-5">
          <div class="text-center">
                <p class="espaco"></p>
                <span class="baixeApp">Antes de começarmos, você precisa ter nosso APP instalado, então vamos lá.</span>	
                <div class="clearfix"></div>
                <a :href="iosUrl" target="_blank">
                    <img src="@/assets/img/app-store.png" class="imgApp">
                </a>
                <a :href="androidUrl" target="_blank">
                    <img src="@/assets/img/app-google.png" class="imgApp">
                </a>
                <div class="clearfix"></div>
            </div>
            <h3 class="mt-5 text-center">
              <h3>Já baixei e instalei o APP</h3>
              <button class="btn btn-lg btn-primary btn-block button success mt-4" type="button" @click="irParaSalaDeEspera">Continuar</button>
            </h3>
        </div>
        <div class="col-md-7">
          <img src="@/assets/img/conexa.vc.svg" alt="" class="img-fluid float-right medico">
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
</template>

<script>
import TopoComponent from '@/components/TopoComponent'

export default {
   components: { TopoComponent },
   created(){
       this.carregarLinkAppEmpresa()
   },
   data() {
    return {
        androidUrl : null,
        iosUrl: null
    }
  },
  methods:{
    irParaSalaDeEspera(){
        location.href = '/sala-espera'
    },
    carregarLinkAppEmpresa(){
      this.$conexaApi.get('/clinica/urls/app/'+sessionStorage.getItem("usuario-clinica"))
      .then((response) => {
          this.androidUrl = response.data.object.urlAndroid
          this.iosUrl = response.data.object.urlIos
          this.acessoDiretoAppUrl = response.data.object.urlAcessoDiretoApp
      }) .catch((error) => {
          this.androidUrl = 'https://play.google.com/store/apps/details?id=us.zoom.videomeetings&hl=pt_BR'
          this.iosUrl = 'https://apps.apple.com/br/app/zoom-cloud-meetings/id546505307'
      }).finally(() => {
         NProgress.done()
      })  
    }
  }
}
</script>

<style scoped>
.imgApp{
    margin-right: 20px;
    margin-top: 10px;
}
</style>